import React from "react";

export const ActiveFilterIcon = (props: React.SVGProps<SVGSVGElement> & {size?: number | string}) => (
  <svg {...props} className={props.className} width={props.size || 30} height={props.size || 30} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25" cy="25" r="23" fill="CurrentColor"/><path d="M28.653 38.124V26.517l9.061-13.123C38.53 11.886 37.504 10 35.86 10H14.14c-1.644 0-2.67 1.887-1.854 3.393l9.061 13.124V44m7.143-5.83c-2.904.697-5.5 2.764-7.087 5.676" stroke="white" strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);